module.exports = __webpack_public_path__ + "static/media/figuras.952e44bc.png";